/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';

export type AlertCategory = 'scores' | 'events';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-alerts-accordion',
  templateUrl: './alerts-accordion.component.html',
  styleUrls: ['./alerts-accordion.component.scss'],
})
export class AlertsAccordionComponent {
  @Input() scoreAlerts: any[] = [];
  @Input() eventAlerts: any[] = [];
  @Input() expanded: { scores: boolean; events: boolean } = {
    scores: true,
    events: false,
  };
  @Input() currentAlertUid: string | null = null;

  @Output() toggleSection = new EventEmitter<AlertCategory>();
  @Output() selectAlert = new EventEmitter<any>();
  @Output() createAlertInCategory = new EventEmitter<AlertCategory>();
  @Output() toggleActive = new EventEmitter<{ checked: boolean; alert: any }>();

  activeCount(alerts: any[]): number {
    return (alerts ?? []).filter((a) => a.active).length;
  }

  onHeaderClick(category: AlertCategory): void {
    this.toggleSection.emit(category);
  }

  onAddClick(event: MouseEvent, category: AlertCategory): void {
    event.stopPropagation();
    this.createAlertInCategory.emit(category);
  }

  onRowClick(alert: any): void {
    this.selectAlert.emit(alert);
  }

  onToggleClick(event: MouseEvent, alert: any): void {
    event.stopPropagation();
    this.toggleActive.emit({ checked: !alert.active, alert });
  }
}
